"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var JSONArrow = function JSONArrow(_ref) {
  var styling = _ref.styling,
      arrowStyle = _ref.arrowStyle,
      expanded = _ref.expanded,
      nodeType = _ref.nodeType,
      onClick = _ref.onClick;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", _extends({}, styling('arrowContainer', arrowStyle), {
      onClick: onClick
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", styling(['arrow', 'arrowSign'], nodeType, expanded, arrowStyle), "\u25B6", arrowStyle === 'double' &&
    /*#__PURE__*/
    _react["default"].createElement("div", styling(['arrowSign', 'arrowSignInner']), "\u25B6")))
  );
};

JSONArrow.propTypes = {
  styling: _propTypes["default"].func.isRequired,
  arrowStyle: _propTypes["default"].oneOf(['single', 'double']),
  expanded: _propTypes["default"].bool.isRequired,
  nodeType: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
JSONArrow.defaultProps = {
  arrowStyle: 'single'
};
var _default = JSONArrow;
exports["default"] = _default;